<div *ngIf="!!editPatientAppUrl" class="patient-app-edit-iframe-wrapper" id="patient-app-edit"> 
	<iframe [attr.id]="patientAppId.Edit" [src]="editPatientAppUrl" class="patient-app-edit-iframe"></iframe>
</div>

<div *ngIf="!!searchPatientAppUrl" class="patient-app-search-iframe-wrapper" id="patient-app-search">
	<iframe [attr.id]="patientAppId.Search" [src]="searchPatientAppUrl" class="patient-app-search-iframe"></iframe>
</div>